module.exports = __webpack_public_path__ + "static/tofi-10ce2a2785fcc93e68e849bd467e0c85.png";